import React, { useEffect, useState } from 'react'
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { TravelAgentOperationsInfoModel } from '../../../Models/TravelAgentModels';
import { SelectDropDownCheckboxInputOption } from '../../../components/commonClass/CommonFunctions';
import { TimePicker } from 'antd';
import { ApiNotRespondMessage, dateFromHourMinSec, formatTimeHourMinute } from '../../../components/commonClass/CommonValidation';
import dayjs from 'dayjs';
import { travelAgentProps } from './TravelAgent.interface';


function TravelAgentOperationsInfo(props: travelAgentProps) {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, TravelAgentId, travelAgentOptionList, setWarningMessages, domainWiseDisable } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [formValue, setFormValue] = useState(new TravelAgentOperationsInfoModel());
  const [operationHours, setOperationHours] = useState<any>(null);

  const [disabled, setDisabled] = useState(location?.state?.disabled ?? true);
  const [editDisabled, setEditDisabled] = useState(location?.state?.editdisabled ?? true);
  const [clearDisabled, setClearDisabled] = useState(true);

  //#region API calling function
  const gettravelagentoperationbyid = async (id: number) => {
    const travelagentoperationbyid = await getAllData(`/midoffice/v1/gettravelagentoperationbyid?travelAgentId=${id}`)
    if (travelagentoperationbyid?.status && travelagentoperationbyid?.data) {
      setFormValue((form) => ({
        ...form,
        TravelAgentId: Number(id),
        AgencyTypeIds: travelagentoperationbyid?.data?.[0]?.agencyTypeIds,
        TravelSegmentIds: travelagentoperationbyid?.data?.[0]?.travelSegmentIds,
        CommunicationChannelIds: travelagentoperationbyid?.data?.[0]?.communicationChannelIds,
        OperationalHour: travelagentoperationbyid?.data?.[0]?.operationalHour ? travelagentoperationbyid?.data?.[0]?.operationalHour : null,
      }))

      setOperationHours(travelagentoperationbyid?.data?.[0]?.operationalHour ? dayjs(dateFromHourMinSec(travelagentoperationbyid?.data?.[0]?.operationalHour)) : null);
    }
  }
  //#endregion

  //#region call API when get token
  useEffect(() => {
    async function fetchData(AgentId: number) {
      dispatch(loaderActions.start())
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        const user: any = GetLocalStorage();
        setFormValue((form) => ({ ...form, TravelAgentId: AgentId, UserId: user?.userMasterID ?? 0 }))
        setIsSaved((save: any) => ({ ...save, OperationsInfo: true }));
        Promise.allSettled([
          gettravelagentoperationbyid(AgentId)
        ])
        dispatch(loaderActions.end())
      }
      else {
        dispatch(loaderActions.end());
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }

    }
    const TAid = Number(location?.state?.Id > 0 ? location?.state?.Id : TravelAgentId);
    TAid > 0 && fetchData(TAid);
  }, [location, TravelAgentId])
  //#endregion

  //#region call Save/Update function when click on "Yes" on tab change
  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      handleSaveUpdate();
    }
  }, [isConfirm])
  //#endregion

  //#region onChange functions
  const selectedAllTravelAgent = travelAgentOptionList?.agencyTypeOption?.map((obj: any) => obj?.value);
  const handleMultiSelectChange = (name: string, e: any) => {
    setIsSaved((save: any) => ({ ...save, OperationsInfo: false }));
    let selectedOptions = e?.map((obj: any) => obj?.value)
    if (name === "AgencyTypeIds") {
      // Find newly selected option
      const added = selectedOptions?.filter(
        (opt: any) => !formValue?.AgencyTypeIds?.some((prev: any) => prev === opt)
      );
      // Find removed option
      const removed = formValue?.AgencyTypeIds?.filter(
        (opt: any) => !selectedOptions?.some((curr: any) => curr === opt)
      );
      selectedOptions = added?.[0] === 5 ? selectedAllTravelAgent : (removed?.length <= 0 ? selectedOptions : (removed?.[0] === 5 ? [] : selectedOptions?.filter((prev: any) => prev !== 5)));
    }
    setEditDisabled(false);
    setClearDisabled(false);
    setFormValue((form) => ({ ...form, [name]: selectedOptions }))
  }

  const handleTimeChange = (name: string, e: any) => {
    setIsSaved((save: any) => ({ ...save, OperationsInfo: false }));
    setEditDisabled(false);
    setClearDisabled(false);
    const timeString = formatTimeHourMinute(e);
    setFormValue((form) => ({ ...form, [name]: e ? `${timeString}:00` : null }));
    setOperationHours(e);
  }
  //#endregion

  //#region insert / update data function
  const handleSaveUpdate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      formValue.TravelAgentId = Number(formValue.TravelAgentId)
      const insertupdatetravelagenoperationsinfo = await postUsersData('/midoffice/v1/insertupdatetravelagenoperationsinfo', formValue);
      if (insertupdatetravelagenoperationsinfo?.status) {
        setIsSaved((save: any) => ({ ...save, OperationsInfo: true }));
        setIsRedirect(true);
        dispatch({ type: 'ALERTING', message: insertupdatetravelagenoperationsinfo?.message || ApiNotRespondMessage });
      }
      else {
        dispatch({ type: 'ALERTING', message: insertupdatetravelagenoperationsinfo?.message || ApiNotRespondMessage });
      }
      dispatch(loaderActions.end());
    }
    else {
      dispatch(loaderActions.end());
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
  }
  //#endregion

  //#region clear function
  const handleClear = () => {
    setIsSaved((save: any) => ({ ...save, OperationsInfo: false }));
    setFormValue((form) => ({
      ...form,
      AgencyTypeIds: [],
      TravelSegmentIds: [],
      CommunicationChannelIds: [],
      OperationalHour: null,
    }));
    setOperationHours(null);
  }
  //#endregion


  //#region back function
  const handleBack = () => {
    navigate('/travel-agent-management');
  }
  //#endregion

  return (
    <div className='row mt-5'>
      <ColumnsDevider label='Agency Type'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={travelAgentOptionList?.agencyTypeOption}
          value={travelAgentOptionList?.agencyTypeOption?.filter((fil) => formValue?.AgencyTypeIds?.includes(fil?.value))}
          onChange={(e) => handleMultiSelectChange("AgencyTypeIds", e)}
          isMulti
          components={{
            Option: SelectDropDownCheckboxInputOption
          }}
          closeMenuOnSelect={false}
          isDisabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder="Agency Type"
          hideSelectedOptions={false}
        />
      </ColumnsDevider>

      <ColumnsDevider label='Preferred Communication Channel'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={travelAgentOptionList?.communicationChannelOption}
          value={travelAgentOptionList?.communicationChannelOption?.filter((fil) => formValue?.CommunicationChannelIds?.includes(fil?.value))}
          onChange={(e) => handleMultiSelectChange("CommunicationChannelIds", e)}
          isMulti
          components={{
            Option: SelectDropDownCheckboxInputOption
          }}
          closeMenuOnSelect={false}
          isDisabled={disabled || domainWiseDisable?.isExternalUser}
          placeholder="Preferred Communication Channel"
          hideSelectedOptions={false}
        />
      </ColumnsDevider>

      <ColumnsDevider label='Operational Hour'>
        <TimePicker
          id='startTime'
          className='form-control defo_border'
          placeholder='--:--'
          format='HH:mm'
          value={operationHours}
          needConfirm={false}
          onChange={(e) => handleTimeChange('OperationalHour', e)}
          disabled={disabled || domainWiseDisable?.isExternalUser}
        />
      </ColumnsDevider>

      <div className='row m-0 p-0'>
        <ColumnsDevider label='Travel Segment Covered'>
          <Select
            className="dropdown select_dropdown custom_class"
            options={travelAgentOptionList?.travelSegmentOption}
            value={travelAgentOptionList?.travelSegmentOption?.filter((fil) => formValue?.TravelSegmentIds?.includes(fil?.value))}
            onChange={(e) => handleMultiSelectChange("TravelSegmentIds", e)}
            isMulti
            components={{
              Option: SelectDropDownCheckboxInputOption
            }}
            closeMenuOnSelect={false}
            isDisabled={disabled || domainWiseDisable?.isExternalUser}
            placeholder="Travel Segment Covered"
            hideSelectedOptions={false}
          />
        </ColumnsDevider>


      </div>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnAdd" onClick={handleSaveUpdate} disabled={editDisabled || disabled || domainWiseDisable?.isExternalUser} > {domainWiseDisable?.loginUserDomainMasterId !== 1 ? "Save AS Draft" : (location?.state?.type === "Edit" ? "Update" : "Save")} </button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnClear" onClick={handleClear} disabled={clearDisabled || disabled || domainWiseDisable?.isExternalUser}>Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnBack" onClick={handleBack}>Back</button>
      </div>
    </div>
  )
}

export default TravelAgentOperationsInfo